/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { HalJson } from '../models/hal-json';
import { Mapping } from '../models/mapping';
import { mappingPut } from '../fn/mappings/mapping-put';
import { MappingPut$Params } from '../fn/mappings/mapping-put';
import { MappingResponse } from '../models/mapping-response';
import { mappingsGet } from '../fn/mappings/mappings-get';
import { MappingsGet$Params } from '../fn/mappings/mappings-get';

@Injectable({ providedIn: 'root' })
export class MappingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mappingsGet()` */
  static readonly MappingsGetPath = '/om/mappings';

  /**
   * Gets Order Manager Tenant and stores mappings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mappingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  mappingsGet$Response(params: MappingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'result'?: {
'_links'?: HalJson;
} & Mapping & {

/**
 * Key to use in next requests to retrieve next page of store mappings
 */
'nextKey'?: string;
};
}>> {
    return mappingsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets Order Manager Tenant and stores mappings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mappingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mappingsGet(params: MappingsGet$Params, context?: HttpContext): Observable<{
'result'?: {
'_links'?: HalJson;
} & Mapping & {

/**
 * Key to use in next requests to retrieve next page of store mappings
 */
'nextKey'?: string;
};
}> {
    return this.mappingsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'result'?: {
'_links'?: HalJson;
} & Mapping & {

/**
 * Key to use in next requests to retrieve next page of store mappings
 */
'nextKey'?: string;
};
}>): {
'result'?: {
'_links'?: HalJson;
} & Mapping & {

/**
 * Key to use in next requests to retrieve next page of store mappings
 */
'nextKey'?: string;
};
} => r.body)
    );
  }

  /** Path part for operation `mappingPut()` */
  static readonly MappingPutPath = '/om/mappings';

  /**
   * Upsert Order Manager tenant/store mappings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mappingPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mappingPut$Response(params: MappingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<MappingResponse>> {
    return mappingPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert Order Manager tenant/store mappings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mappingPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mappingPut(params: MappingPut$Params, context?: HttpContext): Observable<MappingResponse> {
    return this.mappingPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<MappingResponse>): MappingResponse => r.body)
    );
  }

}
